import { useEffect, useState } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { LEGAL_LINKS } from "@/pages/Legal";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export const LegalAdmin = () => {
  const qc = useQueryClient();
  const canEdit = useAuth().user?.platform_role === "admin";
  const [slug, setSlug] = useState("mentions-legales");
  const { data } = useQuery({ queryKey: ["legal", slug], queryFn: () => api.get(`/public/legal/${slug}`).then((r) => r.data) });
  const [v, setV] = useState({ title: "", content: "" });
  useEffect(() => { if (data) { setV({ title: data.title, content: data.content }); } }, [data]);
  const run = async (fn, msg) => {
    try { const r = await fn(); qc.setQueryData(["legal", slug], r.data); toast.success(msg); }
    catch (err) { toast.error(formatApiError(err)); }
  };
  return (
    <section className="card-surface space-y-4 p-6" data-testid="legal-admin">
      <div className="flex flex-wrap gap-2">{LEGAL_LINKS.map(([s, l]) => (
        <Button key={s} size="sm" variant={s === slug ? "default" : "outline"} className="rounded-full" onClick={() => setSlug(s)} data-testid={`legal-admin-tab-${s}`}>{l}</Button>))}</div>
      <p className="text-xs text-muted-foreground">Une ligne commençant par « ## » devient un titre, « - » une puce. {data?.updated_at ? `Modifié le ${new Date(data.updated_at).toLocaleDateString("fr-FR")}.` : "Texte par défaut."}</p>
      <Input value={v.title} onChange={(e) => setV({ ...v, title: e.target.value })} disabled={!canEdit} data-testid="legal-admin-title" />
      <Textarea value={v.content} onChange={(e) => setV({ ...v, content: e.target.value })} disabled={!canEdit} className="min-h-[420px] font-mono text-xs" data-testid="legal-admin-content" />
      {canEdit && <div className="flex flex-wrap gap-2">
        <Button className="rounded-full" onClick={() => run(() => api.put(`/admin/legal/${slug}`, v), "Page enregistrée")} data-testid="legal-admin-save">Enregistrer</Button>
        <Button variant="outline" className="rounded-full" onClick={() => run(() => api.delete(`/admin/legal/${slug}`), "Texte par défaut restauré")} data-testid="legal-admin-reset">Restaurer le texte par défaut</Button>
        <Button variant="ghost" className="rounded-full" asChild><a href={`/legal/${slug}`} target="_blank" rel="noreferrer" data-testid="legal-admin-view">Voir la page</a></Button>
      </div>}
    </section>
  );
};
